module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryBtn"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-center"
  }, [_c('div', {
    staticClass: "iso-box graphic photoshop wallpaper col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('div', {
    staticClass: "portfolio-thumb",
    staticStyle: {
      "text-align": "center",
      "padding": "30px 0px"
    }
  }, [_c('a', {
    staticClass: "btn btnS",
    staticStyle: {
      "width": "100%",
      "max-width": "380px",
      "border-radius": "20px",
      "text-transform": "uppercase"
    },
    attrs: {
      "data-wow-delay": "2000"
    },
    on: {
      "click": function($event) {
        return _vm.$root.goto('Register')
      }
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "3.3vh",
      "min-height": "40px",
      "white-space": "normal"
    }
  }, [_vm._v("For your free 60 day trial")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "3.3vh"
    }
  }, [_vm._v("click here")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6361f496!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/tryBtn.vue
// module id = 717
// module chunks = 0